import { render, staticRenderFns } from "./PantioMarker.vue?vue&type=template&id=94672010&scoped=true"
import script from "./PantioMarker.vue?vue&type=script&lang=js"
export * from "./PantioMarker.vue?vue&type=script&lang=js"
import style0 from "./PantioMarker.vue?vue&type=style&index=0&id=94672010&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94672010",
  null
  
)

export default component.exports